import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../app.constants';

export interface AuthConfig {
    issuer: string;
    clientId: string;
    redirectUri: string;
    scope: string;
}

@Injectable({
    providedIn: 'root'
})
export class OauthConfigService {

    constructor(private http: HttpClient) {}

    /**
     * GET /oauth-clients/{id}
     * Retrieves a single OAuth client by its unique identifier.
     */
    async get(): Promise<AuthConfig> {
        const authConfigFromServer = await this.http.get<AuthConfig>(`${SERVER_API_URL}oauth/config`).toPromise();
        const authConfig : AuthConfig = {
            // Set at runtime. URL of the Identity Provider / STS (Security Token Server)
            issuer: '',
            // URL of application to redirect the user to after login
            redirectUri: window.location.origin + authConfigFromServer.redirectUri,
            // The application's id
            clientId: authConfigFromServer.clientId,
            // set the scope for the permissions the client should request
            // The first four are defined by OIDC.
            // Important: Request offline_access to get a refresh token
            // The api scope is a usecase specific one
            scope: 'openid profile email voucher',
        };
        return authConfig;
    }

    update(authConfig: AuthConfig): Observable<AuthConfig> {
        return this.http.put<AuthConfig>(`${SERVER_API_URL}oauth/config`, authConfig);
    }

}
